import React from 'react';
import Helmet from 'react-helmet';

import LandingPageLayout from '../../../components/LandingPageLayout';
import ContentWrap from '../../../../../components/global/ContentWrap';
import ResortsLandingContainer from './ResortsLanding';

const ResortsLandingView = () => {
  return (
    <LandingPageLayout>
      <Helmet>
        <title>Welcome to Waldo Resorts &ndash; Waldo</title>
      </Helmet>

      <ContentWrap size="lg">
        <div className="content-padded-lg">
          <ResortsLandingContainer />
        </div>
      </ContentWrap>
    </LandingPageLayout>
  );
};

export default ResortsLandingView;
